import React from 'react';
import { Stencil, Spacer, Row, Col, Container } from '@cleartrip/bento';
import { SummaryLoading } from 'components/travelsafe';

function IntLoading() {
	return (
		<>
			<Container>
				<Row>
					<Col className='d-none--xs'>
						<Stencil shimmer height={24} width={100} />
						<Spacer className='pt-5' />
						<Stencil shimmer height={16} width={200} />
						<Spacer className='pt-3' />
						<Stencil shimmer height={16} width={150} />
						<Spacer className='pt-3' />
						<Stencil shimmer height={16} width={80} />
						<Spacer className='pt-3' />
						<Stencil shimmer height={16} width={90} />
						<Spacer className='pt-3' />
						<Stencil shimmer height={16} width={110} />
						<Spacer className='pt-3' />
						<Stencil shimmer height={16} width={180} />
					</Col>
					<Spacer className='mr-15 d-none--xs' />
					<Col span={18} xs={24}>
						<Stencil shimmer height={24} width={200} />
						<Spacer className='pt-5' />
						<SummaryLoading />
						<Spacer className='pt-2' />
						<SummaryLoading />
					</Col>
				</Row>
			</Container>
		</>
	);
}

export default IntLoading;
